"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAndRemoveCventPrefix = void 0;
/**
 * Removes the cvent_ prefix from the data as this is only for Datadog
 * @param data
 * @returns
 */
var transformAndRemoveCventPrefix = function (data) {
    var transformedData = __assign({}, data);
    if (transformedData) {
        Object.keys(transformedData).forEach(function (prop) {
            if (/cvent_/i.test(prop)) {
                // Keys without prefix are the source of truth for the actual values. This is so that we allow consumer to override base props if needed
                var keyWithoutPrefix = prop.replace('cvent_', '');
                var propValue = transformedData[keyWithoutPrefix] || transformedData[prop];
                transformedData[prop.replace('cvent_', '')] = propValue;
                // Finally delete the prop with the cvent_ prefix
                delete transformedData[prop];
            }
        });
    }
    return transformedData;
};
exports.transformAndRemoveCventPrefix = transformAndRemoveCventPrefix;
